import { Component, OnInit } from "@angular/core";
import { map, Observable, of } from "rxjs";
import { Guia } from "src/app/models/Guia";
import { UsuarioGuiasService } from "src/app/services/data-services/usuario.guias.service";
import { UiService } from "src/app/services/ui.service";

@Component({
  selector: "app-navegacao-aba-leis",
  templateUrl: "./navegacao-aba-leis.component.html",
  styleUrls: ["./navegacao-aba-leis.component.scss"],
})
export class NavegacaoAbaLeisComponent implements OnInit {
  public searchText = "";

  public filteredSearch$: Observable<Guia[]>;

  public breakpointLg$: Observable<boolean> = of(false);

  public guias$: Observable<Guia[]> = of([]);

  public isOverlayOpen = false;

  constructor(
    private uiService: UiService,
    private usuarioGuiasService: UsuarioGuiasService
  ) {}

  ngOnInit() {
    this.breakpointLg$ = this.uiService.getBreakpointLg();

    this.guias$ = this.usuarioGuiasService.getGuias();

    this.filteredSearch$ = this.guias$;
  }

  public  overlayOpen() {
    this.isOverlayOpen = !this.isOverlayOpen;
  }

  public async alternarPara(guia: Guia) {
    this.searchText = "";
    await this.usuarioGuiasService.alterarGuiaAtiva(guia.id);
    this.overlayOpen();
  }

  public async fecharGuia(guia: Guia) {
    this.searchText = "";
    await this.usuarioGuiasService.fecharGuia(guia.id);
    this.overlayOpen();
  }

  public searchTextClear() {
    this.searchText = "";
  }

  public searchTextChange() {
    this.filteredSearch$ = this._filter(this.searchText);
  }

  private _filter(value: string): Observable<Guia[]> {
    const filterValue = value.toLowerCase();

    return this.guias$.pipe(
      map((options) =>
        options.filter((option) =>
          option.titulo.toLowerCase().includes(filterValue.toLowerCase())
        )
      )
    );
  }
}
